export default "__VITE_ASSET__3a82acb8__"